type ImportantFootnoteProps = {
  text: string
  className?: string
}
export function ImportantFootnote({
  text,
  className = 'text-xs',
}: ImportantFootnoteProps) {
  return (
    <span className={`${className} text-[#4A505C]`}>
      <p className='font-bold inline'>*Important: </p>
      <p className='font-normal inline'>{text}</p>
    </span>
  )
}
